export default __webpack_public_path__ + "static/bg-c791b1fed7a04d8a617ff8ae866142fb.png";